import React, { useEffect } from 'react';
import {
  Grid,
  FormControl,
  FormLabel,
  GridItem,
  NumberInput,
  NumberInputField,
  Textarea,
  Text,
  FormErrorMessage
} from '@chakra-ui/react';
import { Select as ChakraSelect } from '@chakra-ui/react';
import { formatIndianCurrency } from '../../../../utils/formatters';
import { useNewKBLeadForm } from '../context/NewKBLeadFormContext';

const NewKBBudgetForm = () => {
  // Use the form context for state management
  const { 
    formData, 
    handleFormChange,
    errors
  } = useNewKBLeadForm();

  // Ensure budget object exists
  const budget = formData.budget || { amount: 0, currency: 'INR', notes: '' };
  
  // Log initial values for debugging
  useEffect(() => {
    console.log('[NewKBBudgetForm] Initial Budget Form Values:', budget);
    console.log('[NewKBBudgetForm] Budget Amount Type:', typeof budget.amount);
  }, []);

  // Handle budget field changes
  const handleBudgetChange = (field, value) => {
    console.log(`[NewKBBudgetForm] Updating ${field}:`, value);
    
    // Update the budget object with the new value
    const updatedBudget = {
      ...budget,
      [field]: value
    };
    
    // Update the form data
    handleFormChange('budget', updatedBudget);
  };
  
  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={6}>
      <GridItem>
        <FormControl isInvalid={errors?.budget?.amount}>
          <FormLabel>Budget Amount</FormLabel>
          <NumberInput 
            min={0} 
            value={budget.amount || 0}
            onChange={(valueString) => {
              const value = Number(valueString);
              console.log('[NewKBBudgetForm] Budget Amount Changed:', value);
              handleBudgetChange('amount', value);
            }}
          >
            <NumberInputField placeholder="Enter budget amount" />
          </NumberInput>
          {budget.amount > 0 && (
            <Text fontSize="sm" color="gray.600" mt={1}>
              {formatIndianCurrency(budget.amount)}
            </Text>
          )}
          {errors?.budget?.amount && (
            <FormErrorMessage>{errors.budget.amount}</FormErrorMessage>
          )}
        </FormControl>
      </GridItem>

      <GridItem>
        <FormControl isInvalid={errors?.budget?.currency}>
          <FormLabel>Currency</FormLabel>
          <ChakraSelect
            value={budget.currency || 'INR'}
            onChange={(e) => handleBudgetChange('currency', e.target.value)}
          >
            <option value="INR">INR</option>
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
            <option value="GBP">GBP</option>
          </ChakraSelect>
          {errors?.budget?.currency && (
            <FormErrorMessage>{errors.budget.currency}</FormErrorMessage>
          )}
        </FormControl>
      </GridItem>

      <GridItem colSpan={2}>
        <FormControl isInvalid={errors?.budget?.notes}>
          <FormLabel>Budget Notes</FormLabel>
          <Textarea
            value={budget.notes || ''}
            onChange={(e) => handleBudgetChange('notes', e.target.value)}
            placeholder="Enter budget notes"
            rows={4}
          />
          {errors?.budget?.notes && (
            <FormErrorMessage>{errors.budget.notes}</FormErrorMessage>
          )}
        </FormControl>
      </GridItem>
    </Grid>
  );
};

export default NewKBBudgetForm;
